<template>
  <div>
    <router-link to="/refundDetail"><p>退租</p></router-link>
  </div>
</template>

<script>
export default {
  name: 'refund'
}
</script>

<style scoped>

</style>
